export type QRTCParams =
	{
		serverUrl: string,
		sdkAppId: string,
		userSig: string,
		userId: string,
		userName: string,
		roomId: string,
		maxRetryTime?:number, //最大重连时间 单位ms
		xConferenceToken?:string, //ybmeeting 验证用
		avatarUrl?:string, //ybmeeting
		acceptLanguage?:string 
	}

	export class QRTCError extends Error
{
	errorName:string;
	errorCode: number;
	constructor(errorName:string, message: string, errorCode:number)
	{
		super(message);
		this.name = 'YRTCError';
        this.errorName = errorName;
		this.errorCode = errorCode;
	}
}

	export enum QRTCErrorInfo {
		//进入房间相关
		ERR_ROOM_ENTER_FAIL = 80000101, //进入房间失败
		ERR_ENTER_ROOM_PARAM_NULL = 80000102, //进房参数为空
		ERR_SDK_APPID_INVALID = 80000103, //进房参数 sdkAppId 错误
		ERR_ROOM_ID_INVALID = 80000104, //进房参数 roomId 错误
		ERR_USER_ID_INVALID = 80000105, //进房参数 userID 不正确
		ERR_USER_SIG_INVALID = 80000106, //进房参数 userSig 不正确
		ERR_ENTER_ROOM_TIMEOUT = 80000107, //请求进房超时，请检查网络
		//请求超时相关
		ERR_REQUEST_TIMEOUT = 80000201, //通用信令请求超时
		ERR_CREATE_RTC_TRANSPORT_TIMEOUT = 80000202, //createWebRtcTransport 创建媒体通道响应超时
		ERR_CONNECT_RTC_TRANSPORT_TIMEOUT = 80000203, //connectWebRtcTransport 连接媒体通道响应超时
		ERR_CONSUME_RTC_TIMEOUT = 80000204, //cosume 订阅媒体流响应超时
		ERR_PRODUCE_RTC_TIMEOUT = 80000205, //produce 生产媒体流响应超时
		ERR_LEAVE_RTC_ROOM_TIMEOUT = 80000206, //离开房间请求超时
		//设备操作相关
	ERR_CAMERA_START_FAIL = 80000301, //打开摄像头失败
	ERR_MIC_START_FAIL = 80000302, //打开麦克风失败
	ERR_CAMERA_NO_GRANT = 80000303, //摄像头设备未授权，可能是权限被用户拒绝了
	ERR_MIC_NO_GRANT = 80000304, //麦克风设备未授权，可能是权限被用户拒绝了
	ERR_MIC_INPUT_INTERRUPT = 80000305, //音频输入被打断/恢复
	ERR_SPEAKER_OUTPUT_INTERRUPT = 80000306, //音频输出被打断/恢复
	ERR_MIC_INSERT_OR_REMOVE = 80000307, //本地麦克风设备热插拔
	ERR_SPEAKER_INSERT_OR_REMOVE = 80000308, //本地扬声器设备热插拔
	ERR_CAMERA_INSERT_OR_REMOVE = 80000309, //本地摄像头设备热插拔
	ERR_CAMERA_OCCUPIED = 80000310, //摄像头被占用
	ERR_MIC_OCCUPIED = 80000311, //麦克风被占用
	//编解码相关
	ERR_CODEC_NOT_SUPPROT = 80000401, //编解码格式不支持
		//媒体通道相关
		NETWORK_ICE_CONNECTED = 80000501, //ICE不同的连接状态给到上层connected
		NETWORK_ICE_DISCONNECTED = 80000502,//ICE不同的连接状态给到上层disconnected
		NETWORK_ICE_FAILED = 80000503,//ICE不同的连接状态给到上层failed
		NETWORK_ICE_CLOSED = 80000504,//ICE不同的连接状态给到上层closed
		NETWORK_CONSUME_NO_FIRST_FRAME_IN3S = 80000505,//订阅媒体3s内未收到第一帧数据（onFirstFrameArrived）
		NETWORK_PRODUCE_NO_FIRST_FRAME_IN3S = 80000507,//produce成功后3s内未推送媒体流
		NETWORK_CONSUME_NO__FRAME_IN5S = 80000508,//连续几秒（5/10/15）未收到订阅的指定流的媒体包
		NETWORK_CONSUME_PACKET_DROP_UPTO = 80000509,//订阅的某一路流丢包率大于5%，10%，15%
		NETWORK_PRODUCE_PACKET_DROP_UPTO = 80000510,//生产的某一路流丢包率大于5%，10%，15%
		//其它错误
		ERR_OTHERS = 80000901
	}

export enum QRTCVideoResolution {
	QRTCVideoResolution_120_120,
	QRTCVideoResolution_160_160,
	QRTCVideoResolution_270_270,
	QRTCVideoResolution_480_480,
	QRTCVideoResolution_160_120,
	QRTCVideoResolution_240_180,
	QRTCVideoResolution_280_210,
	QRTCVideoResolution_320_240,
	QRTCVideoResolution_400_300,
	QRTCVideoResolution_480_360,
	QRTCVideoResolution_640_480,
	QRTCVideoResolution_960_720,
	QRTCVideoResolution_160_90,
	QRTCVideoResolution_256_144,
	QRTCVideoResolution_320_180,
	QRTCVideoResolution_480_270,
	QRTCVideoResolution_640_360,
	QRTCVideoResolution_960_540,
	QRTCVideoResolution_1280_720,
	QRTCVideoResolution_1920_1080
}

export type ResolutionInfo = {
	resWidth: number,
	resHeight: number,
	canScaleDown: boolean,
	scaleDownBy: number,
	maxUpBitrate: number,//大流的最大码率
	maxDownBitrate: number //小流的最大码率
}

export enum QRTCVideoResolutionMode {
	QRTCVideoResolutionModeLandscape,//横屏分辨率
	QRTCVideoResolutionModePortrait 	//竖屏分辨率
}


export enum QRTCVideoStreamType {
	QRTCVideoStreamTypeBig,
	QRTCVideoStreamTypeSmall,
	QRTCVideoStreamTypeSub //辅流 屏幕分享
}

export enum QRTCCodecType {
	QRTCCodec_H264Base,
	QRTCCodec_H264Main,
	QRTCCodec_H264High,
	QRTCCodec_H265,
	QRTCCodec_VP9,
	QRTCCodec_VP8,
	QRTCCodec_AV1
}

export type QRTCVideoEncParams = {
	preferCodec?: QRTCCodecType, //优先使用的编码格式
	videoResolution: QRTCVideoResolution,
	resMode: QRTCVideoResolutionMode,
	videoFps: number,
	minVideoBitrate: number,
	maxVideoBitrate: number,
	enableAdjustRes?: boolean //是否允许SDK动态调整分辨率,开启后会对云端录制产生影响,需要开启云端录制的场景建议设置为 NO，中途视频分辨率发生变化后，云端录制出的 MP4 在一般的播放器上都无法正常播放。
	//视频通话模式，若无需云端录制，可以设置为 YES，此时 SDK 会根据当前待带宽情况自动选择合适的分辨率（仅针对 TRTCVideoStreamTypeBig 生效）
}

export enum QRTCMediaDeviceType {
	QRTCMediaDeviceTypeUnknown,
	QRTCMediaDeviceTypeAudioInput,
	QRTCMediaDeviceTypeAudioOutput,
	QRTCMediaDeviceTypeVideoCamera,
	QRTCMediaDeviceTypeVideoWindow,
	QRTCMediaDeviceTypeVideoScreen
}
export type DeviceInfo =
	{
		flag: string,
		name: string,
		version: string
	};

export type QRTCMediaDeviceInfo =
	{
		type: QRTCMediaDeviceType,
		deviceId: string,
		deviceName: string
	}

export type QRTCVolumeInfo =
	{
		userId: string,
		volume: number //说话者的音量 取值范围0-100
	}

export type WebCamInfo =
	{
		device: MediaDeviceInfo,
		resolution: string

	};


export type PeerInfo =
	{
		id: string,
		displayName: string,
		device: any
	}

export type NeedConsumeInfo = {
	peerId: string,
	producerId: string,
	id?: string,
	kind?: 'audio' | 'video',
	rtpParameters?: any,
	//type,
	appData: any,
	producerPaused?: boolean,
	accept?: any
}

// 网络质量信息对象
export type QRTCQualityInfo = {
	userId: string,
	quality: QRTCQuality
}

// 网络状态枚举
export enum QRTCQuality {
	QRTCQuality_Unknown, 	// 未定义
	QRTCQuality_Excellent, // 最好 	
	QRTCQuality_Good, // 好 	
	QRTCQuality_Poor, // 一般 	
	QRTCQuality_Bad, // 差	
	QRTCQuality_Vbad, // 很差
	QRTCQuality_Down // 不可用
}

export enum QRTCVideoFillMode {
	QRTCVideoFillMode_Fill,
	QRTCVideoFillMode_Fit
}

export enum QRTCMediaDeviceChangeEvent {
	QRTCMediaDevice_WebCamAdded,
	QRTCMediaDevice_WebCamRemoved,
	QRTCMediaDevice_MicAdded,
	QRTCMediaDevice_MicRemoved,
	QRTCMediaDevice_SpeakerAdded,
	QRTCMediaDevice_SpeakerRemoved,
	QRTCMediaDevice_Unknown
}

//just for live

export type CameraGroup = {
	id: string,
	name: string
}
export type LivePeerInfo =
	{
		id: string, //直播者的id
		displayName: string,
		device: string,
		producers:[ProducerInfo]
	}

	export type ProducerInfo = 
	{
		id: string,
		kind: string
	}

	export enum QRTCConnectionState {
		BeforeConnection, //第一次连接
		Connected,//已连接
		Disconnected,//连接断开
		Reconnected //重新连接成功
	}


// export type NeedConsumeInfo = {
// 	peerId: string,
// 	producerId: string,
// 	kind?: 'audio' | 'video',
// 	appData: any //TODO by pcg 需要确认服务器给了这个数据
// }